import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react";
import "./popup-modal.css";

const PopupModal = () => {
  const [activeCard, setActiveCard] = useState(null);

  const cards = [
    {
      id: 1,
      title: "Built With Clear Standards",
      content:
        "Every line of code follows shared rules, not individual preferences.",
      checklist: [
        "Agreed on the coding standards prior to the start of development",
        "Consistent Naming, Structure, and Formatting Throughout the codebase",
        "Modular and readable code to minimise risks of dependencies in the future",
        "Documentation written by side of development, and not after",
        "Architectural decision awareness by peers",
        "No rushed shortcuts to create hidden technical debt",
      ],
    },
    {
      id: 2,
      title: "Reviewed By More Than One Pair Of Eyes",
      content:
        "Code is reviewed because assumptions break silently.",
      checklist: [
        "Peer code reviews are required for all major changes",
        "Concentrate on logic clarity and do not worry about whether it works",
        "Edge cases reviewed, not just happy paths",
        "Performance and scalability taken into account during review",
        "Pull requests security implications checked",
        "Feedback which is shared constructively, not mechanically",
      ],
    },
    {
      id: 3,
      title: "Tested As The Product Grows",
      content: "Testing happens while the product is being built, not at the end.",
      checklist: [
        "Unit tests of core logic and critical flows",
        "System interactions Integration testing",
        "Regression testing upon the addition of new features",
        "Manual testing where user behaviour is the most important",
        "Root cause based Bug tracking",
        "No release without passing defined quality checks",
      ],
    },
    {
      id: 4,
      title: "Maintained For The Long Term",
      content: "Quality means the software still makes sense months later.",
      checklist: [
        "Refactoring planned during development cycles",
        "Technical debt not logged and ignored",
        "Post-deployment performance monitoring",
        "Ownership of the codebase well-defined in the team",
        "Updates handled by developers that are familiar with the system",
        "Clean handover when scaling or changing teams",
      ],
    },
  ];

  // Disable body scroll when overlay is active
  useEffect(() => {
    if (activeCard !== null) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
    return () => document.body.classList.remove("no-scroll");
  }, [activeCard]);

  const openOverlay = (cardId) => setActiveCard(cardId);
  const closeOverlay = () => setActiveCard(null);

  const handleOverlayClick = (e) => {
    if (e.target.classList.contains("glass-overlay")) closeOverlay();
  };

  return (
    <div id="code-quality" className="pop-up-section">
      <div className="container">
        <h1 className="code-title text-center">How We Protect Code Quality As Products Grow</h1>

        <div className="seperate-container row justify-content-center">
          {cards.map((card) => (
            <div key={card.id} className="col-12 col-md-6 col-lg-5">
              <div className="popup-card">
                <div className="contents-wrapper">
                  <h1 className="popup-card-title">{card.title}</h1>
                  <p className="popup-card-text">{card.content}</p>
                </div>
                <span className="plus" onClick={() => openOverlay(card.id)}>
                  +
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Overlay Modal */}
        {activeCard !== null && (
          <div className="glass-overlay active" onClick={handleOverlayClick}>
            <div
              className="overlay-content"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="hire__modal__header">
                <h2 className="overlay-title pt-5">
                  {cards.find((c) => c.id === activeCard).title}
                </h2>
                <button className="close-btn" onClick={closeOverlay}>
                  &times;
                </button>
              </div>

              {cards
                .find((c) => c.id === activeCard)
                .checklist.map((item, idx) => (
                  <div key={idx} className="hire__check-item">
                    <Icon
                      className="service-check"
                      icon="lucide:circle-check-big"
                      width="20"
                      color="#0B4F5D"
                    />
                    {item}
                  </div>
                ))}
              <div className="blurred-bg"></div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PopupModal;
